import { getDefaultHeight, SVG } from "./utils";

type Props = {
  color?: string;
} & React.SVGProps<SVGSVGElement>;

export const SimpleDownloadIcon: React.FC<Props> = ({ color, ...svgProps }) => {
  return (
    <SVG
      viewBox="0 0 21.5 21.5"
      xmlns="http://www.w3.org/2000/svg"
      height={getDefaultHeight(svgProps, 21.5)}
      {...svgProps}
      fill={svgProps.fill ?? "none"}
      stroke={color ?? svgProps.stroke ?? "currentColor"}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.5"
    >
      <path d="M10.75.75v14.36M5.365 9.884l5.385 5.385 5.385-5.385M20.75 15.365v1.795c0 1.983-1.194 3.59-2.667 3.59H3.416c-1.473 0-2.667-1.607-2.667-3.59v-1.795" />
    </SVG>
  );
};
